import axiosConfig from "../axiosConfig";
import store from "../storeConfig";

import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";
import AsyncStorage from "@react-native-async-storage/async-storage";

import { unloadTransactions } from "./TransactionActions";
import { setUserInvestID } from "./InvestActions";
import { getCards } from "./CardActions";
import { updateCharity } from "./CharityActions";

const baseURL = getEnvVars().apiUrl;

export function loadUserData() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
    
    try {
      //?memberId=".concat(userId)
      axi.get("/getMemberInfo")
        .then((result) => {
          if (result.data.message.toLowerCase().endsWith("not present in the system")) {
            store.dispatch({
              type: "USER_SET_FIRSTRUN"
            });
          } else {
            store.dispatch({
              type: "USER_DATA",
              user: result.data,
            });
            if (result.data.subscriberDetails.referral_status !== 'done') {
              axi.get("/referralprocess");
            }
            if (result.data.subscriberDetails.referFriendId) {
              getCards(result.data.subscriberDetails.referFriendId);
            }
            const hasCharity = result.data.subscriberDetails.charityId != undefined;
            if (!hasCharity) {
              const hasReferrer = store.getState().user.user.attributes['custom:refererId'];
              if (hasReferrer != undefined) {
                reffererIdToCharityId(hasReferrer);
              }
            }
            axi.get("/banking/withdrawldata").then((result) => {
              store.dispatch({
                type: "USER_WITHDRAWN_AMOUNT",
                amount: result.data.withdrawnAmount
              });
            });
          }
          // console.log(result)
        });
    } catch (error) {
      // console.log(error);
    }
  });
}

export function reffererIdToCharityId(refererId) {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
    var payload = {
      refererId: refererId
    };
  
    axi.post('checkReferral', payload).then((result) => {
      // console.log(result.data);
      let returnID = result.data.data;
      if (returnID != 'Passthrough') {
        updateCharity(returnID);
        user_force_refresh();
      }
    });
  });
}

export function updateUserProfileData(new_gname, new_fname, new_phone, new_email) {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
  
    const cur_gname = store.getState().user.userData.subscriberDetails.givenName || false;
    const cur_fname = store.getState().user.userData.subscriberDetails.familyName || false;
    const cur_phone = store.getState().user.userData.subscriberDetails.phone || false;
    const cur_email = store.getState().user.userData.subscriberDetails.email || false;
    var payload = {
      givenName: new_gname,
      familyName: new_fname,
      phone: new_phone,
      email: new_email
    };
    if (cur_gname != '') payload.givenName = cur_gname;
    if (cur_fname != '') payload.familyName = cur_fname;
    if (cur_phone != 0) payload.phone = cur_phone;
    if (cur_email != 0) payload.email = cur_email;
  
    axi.post('updateMemberProfile', payload);
    return true;
  });
}

export async function checkLastLoginAndRoute(navigation) {
  try {
    var savedLogin = await AsyncStorage.getItem('loginMemory');
    if(savedLogin === null) {
      navigation.navigate("LoginModeChoice");
      return;
    }
    savedLogin = JSON.parse(savedLogin);
    if(savedLogin.mode == 'e' || savedLogin.mode == 'p') {
      navigation.navigate("Login", { formMode: savedLogin.mode, savedUsername: savedLogin.username })
    } else  if (savedLogin.mode == 's') {
      navigation.navigate('LoginModeChoiceSocial');
    } else {
      navigation.navigate("LoginModeChoice");
    }
  } catch (e) {
    console.error(e);
    navigation.navigate("LoginModeChoice");
  }
}

export function user_login(user) {
  if(user.attributes["custom:auraNumber"] === undefined || user.attributes["custom:auraNumber"] === '' || user.attributes["custom:auraNumber"] === 'linking') {
    setUserInvestID(0);
    store.dispatch({
      type: "USER_LOGIN",
      user: user
    });
  } else {
    let cacheDet = user.attributes["custom:cacheDetails"];
    if(cacheDet == '' || cacheDet == undefined) {
      setUserInvestID(0);
    } else {
      let userID = cacheDet.slice(0, -1);
      let encDat = cacheDet.slice(-1);
      setUserInvestID(userID);
      // todo write shortcut if val = 7
      let binStr = parseInt(encDat, 16).toString(2).padStart(3, '0');
      let binArr = binStr.split('');
      store.dispatch({
          type: 'LOAD_USER_BULK_DETAILS',
          KYCVeri: Boolean(parseInt(binArr[0])),
          Banking: Boolean(parseInt(binArr[1])),
          InvestMode: Boolean(parseInt(binArr[2]))
      })
    }
    store.dispatch({
      type: "USER_UNSET_FIRSTRUN",
    });
    store.dispatch({
      type: "USER_FORCE_REFRESH",
    });
    store.dispatch({
      type: "USER_LOGIN",
      user: user
    });
  }
}

export function user_logout() {
  store.dispatch({
    type: "USER_LOGOUT",
  });
  unloadTransactions();
}

export function start_linking(new_user_id) {
  store.dispatch({
    type: "START_LINKING_MODE",
    data: {
      newAccountID: new_user_id
    }
  });
}

export function end_linking() {
  store.dispatch({
    type: "END_LINKING_MODE",
  });
}

export function submit_linking() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });
  
    const cur_gname = store.getState().user.userData.subscriberDetails.givenName || '';
    const cur_fname = store.getState().user.userData.subscriberDetails.familyName || '';
    const cur_phone = store.getState().user.userData.subscriberDetails.phone || 0;
    const cur_email = store.getState().user.userData.subscriberDetails.email || 0;

    const linkingData = store.getState().user.linkingData;

    var payload = {
      linkingAccount: linkingData.newAccountID,
      givenName: cur_gname,
      familyName: cur_fname,
      phone: cur_phone,
      email: cur_email
    };
  
    axi.post('linkingsubmission', payload).then((result) => {
      if (result.data === "Success: Accounts Linked") {
        store.dispatch({
          type: "END_LINKING_MODE",
        });
        return true;
      }
    });
    return true;
  });
}

export function user_force_refresh() {
  setTimeout(() => {
    store.dispatch({
      type: "USER_FORCE_REFRESH",
    });
  }, 1000);
}

export function user_unset_firstrun() {
  setTimeout(() => {
    store.dispatch({
      type: "USER_UNSET_FIRSTRUN",
    });
  }, 1);
}

export function generateTwoFactor() {
  Auth.currentSession().then( (cognitoUserSession) => {
    var axi = axios.create({
      baseURL: baseURL,
      withCredentials: false,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": cognitoUserSession.getIdToken().getJwtToken()
      }
    });

    axi.get("/twofactor");
  });
}